module.exports = __webpack_public_path__ + "img/milva-logo-white.a146f9bd.svg";